import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

const categoryNameMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  jilupian: '纪录片',
  dongman: '动漫',
  zongyi: '综艺',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  if (items && items.length > 0) {
    return (
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600 py-3">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
            )}
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    );
  }

  const pathSegments = location.pathname.split('/').filter(Boolean);
  if (pathSegments.length === 0) return null;

  const breadcrumbItems: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    breadcrumbItems.push({
      label: categoryNameMap[pathSegments[1]] || pathSegments[1],
    });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    breadcrumbItems.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    breadcrumbItems.push({ label: '关于我们' });
  }

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600 py-3">
      {breadcrumbItems.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
          )}
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-500 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}